import React, { useState } from 'react'
import styled from '@emotion/styled'

import ProductListingHeader from './ProductListingHeader'
import ProductListingFilter from './ProductListingFilter'
import ProductListingItem from './ProductListingItem'

import { breakpoints, spacing } from '../../utils/styles'
import { minProductPrice } from '../../utils/helpers'

const sortingOptions = [
  { label: 'Recent', value: 'newest' },
  { label: 'Pret crescator', value: 'price_ascending' },
  { label: 'Pret descrescator', value: 'price_descending' },
  { label: 'A-Z', value: 'alphabetical_ascending' },
  { label: 'Z-A', value: 'alphabetical_descending' },
]

const sortProducts = (products, sortingOption) => {
  let sortedProducts = [...products]
  if (sortingOption === 'newest') {
    sortedProducts.sort(function (a, b) {
      return new Date(b.publishedAt) - new Date(a.publishedAt)
    })
  } else if (sortingOption === 'price_ascending') {
    sortedProducts.sort(function (a, b) {
      return minProductPrice(a) - minProductPrice(b)
    })
  } else if (sortingOption === 'price_descending') {
    sortedProducts.sort(function (a, b) {
      return minProductPrice(b) - minProductPrice(a)
    })
  } else if (sortingOption === 'alphabetical_ascending') {
    sortedProducts.sort(function (a, b) {
      if (a.title < b.title) {
        return -1
      }
      if (a.title > b.title) {
        return 1
      }
      return 0
    })
  } else if (sortingOption === 'alphabetical_descending') {
    sortedProducts.sort(function (a, b) {
      if (a.title < b.title) {
        return 1
      }
      if (a.title > b.title) {
        return -1
      }
      return 0
    })
  }

  return sortedProducts
}

const ProductListing = ({
  title,
  subtitle,
  products,
  headerImage,
  filteringOptions = [],
}) => {
  const [appliedFilters, setAppliedFilters] = useState([])
  const [sortingOption, setSortingOption] = useState(null)

  let filteredProducts = null

  const hasTagOnProduct = (tag, product) => {
    let appliedTagFound = false

    //check tags
    appliedTagFound = product.tags.includes(tag)
    if (appliedTagFound) return true

    //check on product variants options
    const [name, value] = tag.split(':')

    for (let i = 0; i < product.variants.length; i++) {
      const variant = product.variants[i]

      let optionsToCheck = variant.selectedOptions.filter(
        (option) => option.name.toLowerCase() == name
      )
      for (let j = 0; j < optionsToCheck.length; j++) {
        const option = optionsToCheck[j]

        appliedTagFound =
          option.name.toLowerCase() == name &&
          option.value.toLowerCase() == value
        if (appliedTagFound) return true
      }
    }
    //not found on tags or on product variant, skip product
    return false
  }
  if (appliedFilters.length > 0) {
    const appliedTags = appliedFilters.map((filter) => filter.filter)
    filteredProducts = products.filter((el) => {
      //check on el values
      for (let i = 0; i < appliedTags.length; i++) {
        const appliedTag = appliedTags[i]
        //check if applied tag is found on product
        let foundTag = hasTagOnProduct(appliedTag, el)
        if (!foundTag) return false
      }

      return true
    })
  } else {
    filteredProducts = [...products]
  }

  //sort
  if (sortingOption) {
    filteredProducts = sortProducts(filteredProducts, sortingOption)
  }

  return (
    <>
      <ProductListingHeader
        title={title}
        subtitle={subtitle}
        image={headerImage}
      />
      {filteringOptions.length > 0 && (
        <ProductListingFilter
          filteringOptions={filteringOptions}
          products={filteredProducts}
          onFiltersChanged={(filters) => {
            setAppliedFilters(filters)
          }}
        />
      )}

      <div className="resultsHeader sectionContainer">
        <select
          onChange={(event) => {
            if (event.target.value === 'manual') {
              setSortingOption(null)
            } else {
              setSortingOption(event.target.value)
            }
          }}
          className="collectionSort"
        >
          <option value="manual" disabled="">
            Sortare
          </option>
          {sortingOptions.map((el) => (
            <option
              key={el.value}
              value={el.value}
              selected={sortingOption === el.value}
            >
              {el.label}
            </option>
          ))}
        </select>
      </div>
      <div className="productContainer sectionContainer">
        {filteredProducts.map((product) => {
          return <ProductListingItem key={product.id} product={product} />
        })}
      </div>
      <style jsx>{`
        .productContainer {
          display: flex;
          flex-direction: column;
          padding-top: ${spacing.xs}px;
        }
        .resultsHeader {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          margin-top: ${spacing.md}px;
        }
        .collectionSort {
          border: 0 !important;
          padding-right: 0;
          background-position: right center;
          margin-top: 0;
          padding-bottom: 0;

          appearance: none;
          background-color: transparent;
          background-size: 12px 8px;
          background-position: right 10px center;
          background-repeat: no-repeat;
          background-image: url(/images/down-black.svg);
          border-radius: 1px;
          cursor: pointer;
          height: 32px;
          line-height: 32px;
          margin: 0;
          position: relative;
          outline: 0;
          padding-left: ${spacing.sm}px;
          text-align: center;
          width: 100%;
          flex-basis: 160px;
        }
        @media (min-width: ${breakpoints.phablet}px) {
          .productContainer {
            flex-direction: row;
            flex-wrap: wrap;
          }
        }
      `}</style>
    </>
  )
}

export default ProductListing
